var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-star"},[_vm._l((_vm.stars),function(star,index){return _c('img',{key:index,staticClass:"c-star-item",attrs:{"src":star}})}),_c('span',{staticClass:"c-star-value"},[_vm._v(_vm._s((_vm.value * 1.0).toFixed(1)))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }